import { useEffect } from 'react';
import { TweenMax } from 'gsap';
import { usePageVisibility } from './usePageVisibility';
// This fixes bugs when the overlay is open but not visible and graphics pause
// off screen. This makes them still run offscreen.
// https://greensock.com/forums/topic/10051-animations-pause-when-browser-tab-is-not-visible/
export const useNoLagSmoothingWhenHidden = () => {
    const { isVisible } = usePageVisibility();
    useEffect(() => {
        isVisible ? TweenMax.lagSmoothing(400, 40) : TweenMax.lagSmoothing(0, 40);
    }, [isVisible]);
    return {
        isVisible
    };
};
//# sourceMappingURL=useGsapLagSmoothingHideOnPageVisibility.js.map